<template>
    <div>
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4 text-truncate">Add New Site {{ (inputName) ? (" - " + this.inputName) : "" }}</h6>
        <h6 v-else-if="profileId != 0 && this.$attrs.viewMode == true" class="heading-small text-muted mb-4 text-truncate">View Site - {{this.inputName}}</h6>
        <h6 v-else class="heading-small text-muted mb-4 text-truncate">Edit Site - {{this.inputName}}</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

       <b-tabs v-show="profileId != 0 && this.$attrs.viewMode == true" content-class="mt-3">
            <b-tab title="Details" active v-on:click="openDetails"></b-tab>
            <!-- <b-tab title="Auto-replenishment" v-on:click="openAutoRep"></b-tab> -->
            <b-tab title="History" v-on:click="openHistory">
                <b><label>Created By: </label></b>
                {{inputCreatedBy || "System" }} | {{inputCreatedAt | dateFilter}}
                <br>
                <b><label>Updated By:</label></b>
                {{inputUpdatedBy || "System" }} | {{inputUpdatedAt | dateFilter}}
            </b-tab>
        </b-tabs>

        <form id="form-proper" v-show="showDetails">
            <!-- {{site}} -->
            <div v-if="customFormMode == 1">
                <a-tabs defaultActiveKey="1">
                    <a-tab-pane tab="Site" key="1">
                        <base-input alternative="" label="Site Reference Code" placeholder="" v-model="inputCode" input-classes="form-control"/>
                        <base-input alternative="" label="Site Name" placeholder="" v-model="inputName" input-classes="form-control" required/>
                        <base-input label="Location" required>
                          <br>
                          <a-cascader v-model="inputLocation" :options="locationOptions" placeholder="All Locations" style="width: 100%" changeOnSelect />
                        </base-input>
                        <base-input label="Site Type" required>
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="siteTypeName" disabled>
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete
                                        :disableInput="isSiteTypeDisabled"
                                        ref="autocomplete"
                                        placeholder="Search Site Type"
                                        :source="siteTypeEndpoint"
                                        input-class="form-control"
                                        results-property="data"
                                        :results-display="formattedDisplay"
                                        :request-headers="authHeaders"
                                        @selected="getSiteType">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <base-input label="Company" required>
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="companyName" disabled @change="setCompanyTin">
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete
                                        ref="autocomplete"
                                        placeholder="Search Company"
                                        :source="companyEndpoint"
                                        input-class="form-control"
                                        results-property="data"
                                        :results-display="formattedDisplay"
                                        :request-headers="authHeaders"
                                        @selected="getCompany">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <base-input alternative="" label="TIN Number" placeholder="" v-model="inputTin" input-classes="form-control" required disabled/>
                        <base-input alternative="" label="TIN Branch Code" placeholder="" v-model="inputTinBranchCode" input-classes="form-control" required/>
                        <base-input alternative="" label="Site Address" placeholder="" input-classes="form-control">
                            <textarea class="form-control" rows="4" v-model="inputAddress"></textarea>
                        </base-input>
                        <base-input alternative="" label="Site IP Address" placeholder="" v-model="ipAddress" input-classes="form-control" />

                        <!--  Contact Details-->
                        <base-input alternative="" label="Contact Person" placeholder="" v-model="contactPerson" input-classes="form-control" />
                        <base-input alternative="" label="Contact Number" placeholder="" v-model="contactNumber" input-classes="form-control" />
                        <base-input label="Email" placeholder="" v-model="inputEmail" input-classes="form-control" type="email" name="inputEmail"/>

                        <base-input alternative="" label="Remark">
                            <textarea rows="4" class="form-control" v-model="inputRemark"/>
                        </base-input>
                        <hr><h4>Site Checklist</h4>
                        <base-checkbox class="mb-3" v-model="checkboxes.isRemote">
                            This is a Remote Site
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.isAllowedMergingSales">
                            Enable merged submission of sales and inventory to branch total
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.canDownloadPosInventory">
                            Enable Download for POS Inventory
                        </base-checkbox>
                        <!-- <base-checkbox class="mb-3" v-model="checkboxes.canDownloadPosSitePricing">
                            Enable Download for POS Site Pricing
                        </base-checkbox> -->
                        <!-- <base-checkbox class="mb-3" v-model="checkboxes.canDownloadTerminalSettings">
                            Enable the Download for Terminal Setting
                        </base-checkbox> -->
                        <base-checkbox class="mb-3" v-model="checkboxes.isStrickLotCodes">
                            Enable Strict Lot Codes in Back Office
                        </base-checkbox>
                        <!-- <base-checkbox class="mb-3" v-model="checkboxes.isSupportingZippedDocument" required>
                            Support Zipped Document
                        </base-checkbox> -->
                        <base-checkbox class="mb-3" v-model="checkboxes.isEnableEcomPos">
                            Enable Ecom POS
                        </base-checkbox>
                        <base-input label="Select Ecom Terminal" required v-if="checkboxes.isEnableEcomPos">
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="terminalName" disabled>
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete
                                        ref="autocomplete"
                                        placeholder="Search Terminal"
                                        :source="termialEndpoint"
                                        input-class="form-control"
                                        results-property="data"
                                        :results-display="formattedDisplay"
                                        :request-headers="authHeaders"
                                        @selected="getTerminal">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <base-checkbox class="mb-3" v-model="checkboxes.isEnableSiteReplication" :disabled="disableReplication">
                            Replicate Site Master Data / Profiles
                        </base-checkbox>
                        <base-input label="Select Site" required v-if="checkboxes.isEnableSiteReplication">
                            <br/>
                            <span v-if="disableReplication">Site Replicated : {{this.inputReplicateSiteId}}</span>
                            <autocomplete
                                ref="autocomplete"
                                placeholder="Search Sites"
                                :source="sitesEndpoint"
                                :disable-input="disableReplication"
                                input-class="form-control"
                                results-property="data"
                                :results-display="formattedDisplay"
                                :request-headers="authHeaders"
                                @selected="getSite">
                            </autocomplete>
                        </base-input>

                        <br><br>
                        <base-input class="row">
                            <div class="col-md-10">
                                <h3>Site Reset</h3>
                                <h4>Reset this Site</h4>
                                <small>Flag this site to allow transaction reset. This will also tag all terminals under this site as for reset.</small>
                            </div>
                            <div class="float-right col-md-2">
                                <a-switch v-model="checkboxes.isEnableSiteReset" @change='onChange'/>
                            </div>
                        </base-input>
                        <br><br>
                    </a-tab-pane>
                    <a-tab-pane tab="Default Sublocation" key="2" forceRender>
                        <div v-if="profileId == 0 || this.$attrs.viewMode == true">
                            <base-input alternative="" label="Code" placeholder="" v-model="inputSublocationCode" input-classes="form-control"/>
                            <base-input alternative="" label="Name" placeholder="" v-model="inputSublocationName" input-classes="form-control" required/>
                            <base-input label="Type">
                                <select class="form-control form-control-sm" v-model="inputSublocationType">
                                    <option v-for="option in sublocationTypeOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{option.value}}
                                    </option>
                                </select>
                            </base-input>
                            <base-input label="Salesman">
                                <div class="form-group row">
                                    <div class="col-sm-6">
                                        <input type="text" class="form-control" v-model="salesmanName" disabled>
                                    </div>
                                    <div class="col-sm-6">
                                        <autocomplete
                                            ref="autocomplete"
                                            placeholder="Search Salesman"
                                            :source="salesmanEndpoint"
                                            input-class="form-control"
                                            results-property="data"
                                            :results-display="formattedDisplay"
                                            :request-headers="authHeaders"
                                            @selected="getSalesman">
                                        </autocomplete>
                                    </div>
                                </div>
                            </base-input>
                            <base-input alternative="" label="Description">
                                <textarea rows="4" class="form-control" v-model="inputDescription"/>
                            </base-input>
                            <base-input alternative="" label="Tags">
                                <textarea rows="4" class="form-control" v-model="inputTags"/>
                            </base-input>
                        </div>
                        <div v-else>
                            <base-input label="Sublocation">
                                <div class="form-group row">
                                    <div class="col-sm-6">
                                        <input type="text" class="form-control" v-model="sublocationName" disabled>
                                    </div>
                                    <div class="col-sm-6">
                                        <autocomplete
                                            ref="autocomplete"
                                            placeholder="Search Sublocation"
                                            :source="sublocationEndpoint"
                                            input-class="form-control"
                                            results-property="data"
                                            :results-display="formattedDisplay"
                                            :request-headers="authHeaders"
                                            @selected="getSublocation">
                                        </autocomplete>
                                    </div>
                                </div>
                            </base-input>
                        <br><br><br><br>
                        </div>
                    </a-tab-pane>
                    <a-tab-pane tab="Auto-replenishment" key="3">
                        <base-checkbox v-model="isEnableAutoRep" class="mb-3">
                            Enable Auto-Replenishment
                        </base-checkbox>
                        <base-input v-if="isEnableAutoRep" type="number" label="Replenishment Priority" placeholder="0" v-model="replenishmentPriority" input-classes="form-control" />
                    </a-tab-pane>
                </a-tabs>
            </div>
            <div v-if="customFormMode == 2">
                <!-- Override -->
                <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups}" :formSettings="this.site" @valueUpdated="updateSettings" :key="dynamicFormKey"/>
            </div>
            <div v-if="customFormMode == 3">
                <!-- Append -->
                <a-tabs defaultActiveKey="1">
                    <a-tab-pane tab="Site" key="1">
                        <base-input alternative="" label="Site Reference Code" placeholder="" v-model="inputCode" input-classes="form-control"/>
                        <base-input alternative="" label="Site Name" placeholder="" v-model="inputName" input-classes="form-control" required/>
                        <base-input label="Location">
                          <br>
                          <a-cascader v-model="inputLocation" :options="locationOptions" placeholder="All Locations" style="width: 100%" changeOnSelect />
                        </base-input>
                        <base-input label="Site Type" required>
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="siteTypeName" disabled>
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete
                                        :disableInput="isSiteTypeDisabled"
                                        ref="autocomplete"
                                        placeholder="Search Site Type"
                                        :source="siteTypeEndpoint"
                                        input-class="form-control"
                                        results-property="data"
                                        :results-display="formattedDisplay"
                                        :request-headers="authHeaders"
                                        @selected="getSiteType">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <base-input label="Company" required>
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="companyName" disabled @change="setCompanyTin">
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete
                                        ref="autocomplete"
                                        placeholder="Search Company"
                                        :source="companyEndpoint"
                                        input-class="form-control"
                                        results-property="data"
                                        :results-display="formattedDisplay"
                                        :request-headers="authHeaders"
                                        @selected="getCompany">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <base-input alternative="" label="TIN Number" placeholder="" v-model="inputTin" input-classes="form-control" required disabled/>
                        <base-input alternative="" label="TIN Branch Code" placeholder="" v-model="inputTinBranchCode" input-classes="form-control" required/>
                        <base-input alternative="" label="Site Address" placeholder="" input-classes="form-control">
                            <textarea class="form-control" rows="4" v-model="inputAddress"></textarea>
                        </base-input>
                        <base-input alternative="" label="Site IP Address" placeholder="" v-model="ipAddress" input-classes="form-control" />

                        <!--  Contact Details-->
                        <base-input alternative="" label="Contact Person" placeholder="" v-model="contactPerson" input-classes="form-control" />
                        <base-input alternative="" label="Contact Number" placeholder="" v-model="contactNumber" input-classes="form-control" />
                        <base-input alternative="" label="Email" placeholder="" v-model="inputEmail" input-classes="form-control" />

                        <base-input alternative="" label="Remark">
                            <textarea rows="4" class="form-control" v-model="inputRemark"/>
                        </base-input>
                        <hr><h4>Site Checklist</h4>
                        <base-checkbox class="mb-3" v-model="checkboxes.isRemote">
                            This is a Remote Site
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.isAllowedMergingSales">
                            Enable merged submission of sales and inventory to branch total
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.canDownloadPosInventory">
                            Enable Download for POS Inventory
                        </base-checkbox>
                        <!-- <base-checkbox class="mb-3" v-model="checkboxes.canDownloadPosSitePricing">
                            Enable Download for POS Site Pricing
                        </base-checkbox> -->
                        <!-- <base-checkbox class="mb-3" v-model="checkboxes.canDownloadTerminalSettings">
                            Enable the Download for Terminal Setting
                        </base-checkbox> -->
                        <base-checkbox class="mb-3" v-model="checkboxes.isStrickLotCodes">
                            Enable Strict Lot Codes in Back Office
                        </base-checkbox>
                        <!-- <base-checkbox class="mb-3" v-model="checkboxes.isSupportingZippedDocument" required>
                            Support Zipped Document
                        </base-checkbox> -->
                        <base-checkbox class="mb-3" v-model="checkboxes.isEnableEcomPos">
                            Enable Ecom POS
                        </base-checkbox>
                        <base-input label="Select Ecom Terminal" required v-if="checkboxes.isEnableEcomPos">
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="terminalName" disabled>
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete
                                        ref="autocomplete"
                                        placeholder="Search Terminal"
                                        :source="termialEndpoint"
                                        input-class="form-control"
                                        results-property="data"
                                        :results-display="formattedDisplay"
                                        :request-headers="authHeaders"
                                        @selected="getTerminal">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <base-checkbox class="mb-3" v-model="checkboxes.isEnableSiteReplication" :disabled="disableReplication">
                            Replicate Site Master Data / Profiles
                        </base-checkbox>
                        <base-input label="Select Site" required v-if="checkboxes.isEnableSiteReplication">
                            <br/>
                            <span v-if="disableReplication">Site Replicated : {{this.inputReplicateSiteId}}</span>
                            <autocomplete
                                ref="autocomplete"
                                placeholder="Search Sites"
                                :source="sitesEndpoint"
                                input-class="form-control"
                                results-property="data"
                                :disable-input="disableReplication"
                                :results-display="formattedDisplay"
                                :request-headers="authHeaders"
                                @selected="getSite">
                            </autocomplete>
                        </base-input>
                        <br><br>
                        <base-input class="row">
                            <div class="col-md-10">
                                <h3>Site Reset</h3>
                                <h4>Reset this Site</h4>
                                <small>Flag this site to allow transaction reset. This will also tag all terminals under this site as for reset.</small>
                            </div>
                            <div class="float-right col-md-2">
                                <a-switch v-model="checkboxes.isEnableSiteReset" @change='onChange'/>
                            </div>
                        </base-input>
                        <br><br>
                    </a-tab-pane>
                    <a-tab-pane tab="Default Sublocation" key="2" forceRender>
                        <div v-if="profileId == 0 || this.$attrs.viewMode == true">
                            <base-input alternative="" label="Code" placeholder="" v-model="inputSublocationCode" input-classes="form-control" />
                            <base-input alternative="" label="Name" placeholder="" v-model="inputSublocationName" input-classes="form-control" required/>
                            <base-input label="Type">
                                <select class="form-control form-control-sm" v-model="inputSublocationType">
                                    <option v-for="option in sublocationTypeOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{option.value}}
                                    </option>
                                </select>
                            </base-input>
                            <base-input label="Salesman">
                                <div class="form-group row">
                                    <div class="col-sm-6">
                                        <input type="text" class="form-control" v-model="salesmanName" disabled>
                                    </div>
                                    <div class="col-sm-6">
                                        <autocomplete
                                            ref="autocomplete"
                                            placeholder="Search Salesman"
                                            :source="salesmanEndpoint"
                                            input-class="form-control"
                                            results-property="data"
                                            :results-display="formattedDisplay"
                                            :request-headers="authHeaders"
                                            @selected="getSalesman">
                                        </autocomplete>
                                    </div>
                                </div>
                            </base-input>
                            <base-input alternative="" label="Description">
                                <textarea rows="4" class="form-control" v-model="inputDescription"/>
                            </base-input>
                            <base-input alternative="" label="Tags">
                                <textarea rows="4" class="form-control" v-model="inputTags"/>
                            </base-input>
                        </div>
                        <div v-else>
                            <base-input label="Sublocation">
                                <div class="form-group row">
                                    <div class="col-sm-6">
                                        <input type="text" class="form-control" v-model="sublocationName" disabled>
                                    </div>
                                    <div class="col-sm-6">
                                        <autocomplete
                                            ref="autocomplete"
                                            placeholder="Search Sublocation"
                                            :source="sublocationEndpoint"
                                            input-class="form-control"
                                            results-property="data"
                                            :results-display="formattedDisplay"
                                            :request-headers="authHeaders"
                                            @selected="getSublocation">
                                        </autocomplete>
                                    </div>
                                </div>
                            </base-input>
                        <br><br><br><br>
                        </div>

                    </a-tab-pane>
                    <a-tab-pane tab="Auto-replenishment" key="3">
                        <base-checkbox v-model="isEnableAutoRep" class="mb-3">
                            Enable Auto-Replenishment
                        </base-checkbox>
                        <base-input v-if="isEnableAutoRep" type="number" label="Replenishment Priority" placeholder="0" v-model="replenishmentPriority" input-classes="form-control" />
                    </a-tab-pane>
                    <a-tab-pane tab="Custom Fields" key="4" forceRender>
                        <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups_append}" :formSettings="this.site" @valueUpdated="updateSettings" :key="dynamicFormKey" :showErrors="false"/>
                    </a-tab-pane>
                </a-tabs>
            </div>

            <div class='mt-5' v-if="this.$attrs.viewMode != true">
                <div v-if="serverType == 'ho'" style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Add</button>
                    <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button>
                </div>
                <div v-else style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">Close</button>
                </div>
            </div>
        </form>

    </div>
</template>


<script>
import HTTPRequest from '../../controllers/httpRequest.js'
import DynamicForm from '../DynamicForm.vue'
import secureStorage from '../../controllers/secureStorage.js'
import ValidateField from '../../components/validateFormUtils.js'
import { mapState } from 'vuex'
import Autocomplete from 'vuejs-auto-complete'
import moment from 'moment'
var component_x;
export default {
    components: {
        Autocomplete, DynamicForm
    },
    computed: {
        ...mapState(['endPoint', 'profileId', 'serverType']),
    },
    mounted: async function() {
        // Meta-data Call
        const sytemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/Site?field_name=name'  , null)
        const sytemModuleId = sytemModule.id
        const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + sytemModuleId + '?field_name=system_module_id'  , null)

        // this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view'  , null)
        this.locationOptions = this.$attrs.locationOptions

        if(this.isJsonString(accSystemModuleRequest.meta) == true){
            const accSystemModule = JSON.parse(accSystemModuleRequest.meta)
            if(accSystemModule != null){
                if(accSystemModule.form_mode != undefined){
                    this.customFormMode = accSystemModule.form_mode
                }
                if(accSystemModule.customized_forms != undefined){
                    this.customForm = accSystemModule.customized_forms
                }
            }
        }

        if(this.serverType == 'branch' || this.$attrs.viewMode == true){
            var form = document.getElementById("form-proper")
            var elements = form.elements;
            for (var i = 0, len = elements.length; i < len; ++i) {
                elements[i].disabled = true;
            }
        }
        component_x = this
        if( component_x.profileId > 0){
            var data = await HTTPRequest.getRequest(component_x.endPoint + 'sites/' + component_x.profileId, null)
            if(data == undefined){
                component_x.$router.go()
            } else {
                if(data["error"] == undefined){
                    component_x.inputCode = data["refcode"]
                    this.site = data
                    if(data["location_path"] != null) component_x.inputLocation = JSON.parse(data["location_path"])
                    component_x.inputName = data["name"]
                    component_x.contactPerson = data["contact_person"]
                    component_x.contactNumber = data["telephone"]
                    component_x.inputSiteType = data["site_type_id"]
                    component_x.isEnableAutoRep = data["is_enable_autorep"] || false
                    component_x.replenishmentPriority = data["replenishment_priority"] || 0
                    component_x.inputCompany = data["company_id"]
                    component_x.inputTin = data["tin"]
                    component_x.inputTinBranchCode = data["tin_branch_code"]
                    component_x.inputAddress = data["address"]
                    component_x.ipAddress = data["ip_address"]
                    component_x.inputRemark = data["remark"]
                    component_x.inputCreatedBy = data["created_by"]
                    component_x.inputCreatedAt = data["created_at"]
                    component_x.inputUpdatedBy = data["updated_by"]
                    component_x.inputUpdatedAt = data["updated_at"]
                    component_x.checkboxes.isRemote = data["is_remote"]
                    component_x.companyName = data["company_name"]
                    component_x.siteTypeName = data["site_type"]
                    component_x.checkboxes.isAllowedMergingSales = data["is_allowed_merging_sales"]
                    component_x.checkboxes.canDownloadPosInventory = data["can_download_pos_inventory"]
                    component_x.checkboxes.isEnableSiteReset = data["is_for_resetting"]
                    // component_x.checkboxes.canDownloadPosSitePricing = data["can_download_pos_site_pricing"]
                    // component_x.checkboxes.canDownloadTerminalSettings = data["can_download_terminal_settings"]
                    component_x.checkboxes.isStrickLotCodes = data["is_strick_lot_codes"]
                    // component_x.checkboxes.isSupportingZippedDocument = data["is_supporting_zipped_document"]
                    component_x.checkboxes.isEnableEcomPos = data["ecomm_terminal_id"]!= undefined && data["ecomm_terminal_id"]!= null ? true : false
                    component_x.terminalName = data["terminal_name"]
                    component_x.inputTerminal = data["ecomm_terminal_id"]
                    component_x.disableReplication = data["replicated_site_id"]!= undefined && data["replicated_site_id"]!= null ? true : false
                    component_x.checkboxes.isEnableSiteReplication = data["replicated_site_id"]!= undefined && data["replicated_site_id"]!= null ? true : false
                    component_x.inputReplicateSiteId = data["replicated_site_id"]
                    component_x.inputEmail = data["email"]


                    if (data["serialized_sublocation"]) {
                        component_x.inputSublocationCode = data["serialized_sublocation"]["code"]
                        component_x.inputSublocationName = data["serialized_sublocation"]["name"]
                        component_x.inputSublocationType = data["serialized_sublocation"]["sublocation_type"]
                        component_x.inputSalesman = data["serialized_sublocation"]["salesman_id"]
                        component_x.salesmanName = data["serialized_sublocation"]["salesman_name"]
                        component_x.inputDescription = data["serialized_sublocation"]["description"]
                        component_x.inputTags = data["serialized_sublocation"]["tags"]
                        component_x.inputSublocation = data["serialized_sublocation"]["id"]
                        component_x.sublocationName = data["serialized_sublocation"]["name"]
                    }
                } else {
                    this.errors = data["error"].split(",") //format will change when error message has comma
                    //component_x.$router.push("/")
                }
            }
        }
        this.dynamicFormKey++;
    },
    data: function(){
        return {
            // Location Implem
            inputLocation: null,
            locationOptions: [],

            inputCode: '',
            inputName: '',
            inputSiteType: '',
            isSiteTypeDisabled: false,
            isEnableAutoRep: false,
            replenishmentPriority: 0,
            siteTypeName: '',
            inputCompany: '',
            companyName: '',
            inputTin: '',
            inputTinBranchCode: '',
            inputAddress: '',
            ipAddress: '',
            inputRemark: '',
            contactNumber: '',
            contactPerson: '',
            inputCreatedBy: '',
            inputCreatedAt: '',
            inputUpdatedBy: '',
            inputUpdatedAt: '',
            showDetails: true,
            inputEmail: null,
            checkboxes: {
                isRemote: null,
                isAllowedMergingSales: null,
                canDownloadPosInventory: null,
                // canDownloadPosSitePricing: null,
                // canDownloadTerminalSettings: null,
                isStrickLotCodes: null,
                // isSupportingZippedDocument: null,
                isEnableEcomPos:null,
                isEnableSiteReplication: null,
                isEnableSiteReset: null
            },
            authHeaders: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
            errors: [],

            // FOR META-DATA
            customFormMode: 1,
            customForm: {},
            profileData: {},
            dynamicFormKey: 0,
            site: {},
            formErrors: [],

            inputSublocationCode: '',
            inputSublocationName: '',
            inputSite: '',
            inputSublocationType: '',
            sublocationTypeOptions: [
                {key: null, value: null},
                {key: "T", value: "Truck"},
                {key: "S", value: "Store-front"},
                {key: "B", value: "Backroom"}
            ],
            salesmanName: '',
            inputSalesman: '',
            inputDescription: '',
            inputTags: '',
            sublocationName: '',
            inputSublocation: '',
            terminalName:'',
            inputTerminal:'',
            inputReplicateSiteId: '',
            disableReplication: false,
        }
    },
    filters: {
        dateFilter: function (timestamp) {
            return moment(timestamp).format('L LTS')
        }
    },
    methods: {
        updateSettings(newFormSettings, settingsGrouping, errors){
            var formSettingsCopy = this.site
            var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
            this.formErrors = errors

            if(this.customFormMode == 3) {
                this.errors = errors
            }

            this.site = mergedHash
        },
        isJsonString(str) {
            try {
                var json = JSON.parse(str);
                return (typeof json === 'object');
            } catch (e) {
                return false;
            }
        },
        openDetails() {
            this.showDetails = true
        },
        openHistory() {
            this.showDetails = false
        },
        sublocationEndpoint (input) {
            return this.endPoint + '/sublocations?name=' + input;
        },
        getSublocation (group) {
            this.sublocationName = group.display;
            this.inputSublocation = group.value;
        },
        salesmanEndpoint (input) {
            return this.endPoint + '/salesmen?name=' + input;
        },
        getSalesman (group) {
            this.salesmanName = group.display;
            this.inputSalesman = group.value;
        },
        companyEndpoint (input) {
            return this.endPoint + '/companies?name=' + input;
        },
        termialEndpoint (input) {
            return this.endPoint + '/terminals?name=' + input;
        },
        sitesEndpoint(input){
            return this.endPoint + '/sites/get_valid_sites?name=' + input;
        },
        getCompany (group) {
            this.companyName = group.display;
            this.inputCompany = group.value;

            this.setCompanyTin(this.inputCompany)
        },
        getTerminal (group) {
            console.log(group)
            this.terminalName = group.display;
            this.inputTerminal = group.value;
        },
        getSite(group){
            this.siteName = group.display;
            this.inputReplicateSiteId = group.value;
        },
        siteTypeEndpoint (input) {
            return this.endPoint + '/site_types?name=' + input;
        },
        getSiteType (group) {
            this.siteTypeName = group.display;
            this.inputSiteType = group.value;
        },
        formattedDisplay (result) {
          return result.name + ' [' + result.code + ']';
        },
        validateForm(){
            this.errors = [];
            // this.errors.push(ValidateField.required('Site Reference Code', this.inputCode));
            // this.errors.push(ValidateField.alphanumericWithSpecialChars('Site Reference Code', this.inputCode));
            this.errors.push(ValidateField.required('Site Name', this.inputName));
            // this.errors.push(ValidateField.alphanumericWithSpecialChars('Site Name', this.inputName));
            this.errors.push(ValidateField.required('Site Type', this.inputSiteType));
            this.errors.push(ValidateField.required('Company', this.inputCompany));
            this.errors.push(ValidateField.required('TIN Number', this.inputTin));
            this.errors.push(ValidateField.required('TIN Branch Code', this.inputTinBranchCode));
            this.errors.push(ValidateField.alphanumericWithSpecialChars('TIN Number', this.inputTin));
            this.errors.push(ValidateField.alphanumericWithSpecialChars('TIN Branch Code', this.inputTinBranchCode));
            this.errors.push(ValidateField.alphanumericWithNewline('Site Address', this.inputAddress));
            this.errors.push(ValidateField.required('Location', this.inputLocation));
            if(this.inputEmail != null && this.inputEmail != ""){
                this.errors.push(ValidateField.emailFormat('Email', this.inputEmail));
            }

            if(this.checkboxes.isEnableEcomPos != null && this.checkboxes.isEnableEcomPos != ""){
                this.errors.push(ValidateField.required('Terminal', this.inputTerminal));
            }
            if(this.checkboxes.isEnableSiteReplication != null && this.checkboxes.isEnableSiteReplication != false){
                this.errors.push(ValidateField.required('Site Replication', this.inputReplicateSiteId))
            }
            //this.errors.push(ValidateField.isNull('Support Zipped Document', this.checkboxes.isSupportingZippedDocument));
            if (this.profileId == 0) {
                this.errors.push(ValidateField.required('Sublocation Name', this.inputSublocationName));
                // this.errors.push(ValidateField.required('Sublocation Code', this.inputSublocationCode));
            }else{
                 this.errors.push(ValidateField.required('Sublocation Name', this.sublocationName));
            }
            this.errors.push(ValidateField.alphanumericWithSpace('Sublocation Description', this.inputDescription));
            this.errors.push(ValidateField.alphanumericWithSpace('Sublocation Tags', this.inputTags));

            this.errors = this._.compact(this.errors);
            document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
            return this.errors.length;
        },
        async setCompanyTin(company_id) {
            var request = await HTTPRequest.getRequest(this.endPoint + '/companies?id=' + company_id)
            
            if (request != null) {
                request.data.map((company) => {
                    if (company.id == company_id) {
                        this.inputTin = company.tin
                    }
                })
            }
        },
        create: async function() {
            if(!this.validateForm()) {
                var sitePayload = {site: {name: this.inputName.trim(), refcode: this.inputCode.trim(), location_id: this.inputLocation[this.inputLocation.length -1], location_path: JSON.stringify(this.inputLocation),
                                                site_type_id: this.inputSiteType, company_id: this.inputCompany,
                                                tin: this.inputTin, tin_branch_code: this.inputTinBranchCode, address: this.inputAddress, ip_address: this.ipAddress,
                                                remark: this.inputRemark, contact_person: this.contactPerson, telephone: this.contactNumber,
                                                is_remote: this.checkboxes.isRemote,
                                                is_allowed_merging_sales: this.checkboxes.isAllowedMergingSales,
                                                can_download_pos_inventory: this.checkboxes.canDownloadPosInventory,
                                                // can_download_pos_site_pricing: this.checkboxes.canDownloadPosSitePricing,
                                                // can_download_terminal_settings: this.checkboxes.canDownloadTerminalSettings,
                                                is_strick_lot_codes: this.checkboxes.isStrickLotCodes,
                                                is_for_resetting: this.checkboxes.isEnableSiteReset,
                                                is_enable_autorep: this.isEnableAutoRep,
                                                replenishment_priority: this.replenishmentPriority,
                                                // is_supporting_zipped_document: this.checkboxes.isSupportingZippedDocument,
                                                email: this.inputEmail,
                                                ecomm_terminal_id:this.inputTerminal,
                                                replicated_site_id: this.inputReplicateSiteId,
                                                sublocation: {
                                                    name: this.inputSublocationName.trim(), code: this.inputSublocationCode.trim(),
                                                    sublocation_type: this.inputSublocationType, salesman_id: this.inputSalesman,
                                                    description: this.inputDescription, tags: this.inputTags
                                                }
                                        }
                                    }
                var mergedHash = Object.assign({}, this.site, sitePayload.site);
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'sites', null, {site: mergedHash})
                if(post_request == undefined){
                    this.$emit('refreshPage', event)
                } else {
                    if(post_request["error"] == undefined){
                       this.$emit('refreshPage', event)
                    } else {
                        this.errors = post_request["error"].split(",") //format will change when error message has comma
                        //this.$router.push("/")
                    }
                }
            }
        },
        update: async function(){
            if(!this.validateForm()) {
                var sitePayload = {site: {name: this.inputName.trim(), refcode: this.inputCode.trim(), location_id: this.inputLocation[this.inputLocation.length - 1], location_path: JSON.stringify(this.inputLocation),
                                                site_type_id: this.inputSiteType, company_id: this.inputCompany,
                                                tin: this.inputTin, tin_branch_code: this.inputTinBranchCode, address: this.inputAddress,
                                                remark: this.inputRemark, contact_person: this.contactPerson, telephone: this.contactNumber,
                                                is_remote: this.checkboxes.isRemote, ip_address: this.ipAddress,
                                                is_allowed_merging_sales: this.checkboxes.isAllowedMergingSales,
                                                can_download_pos_inventory: this.checkboxes.canDownloadPosInventory,
                                                is_enable_autorep: this.isEnableAutoRep,
                                                replenishment_priority: this.replenishmentPriority,
                                                // can_download_pos_site_pricing: this.checkboxes.canDownloadPosSitePricing,
                                                // can_download_terminal_settings: this.checkboxes.canDownloadTerminalSettings,
                                                is_strick_lot_codes: this.checkboxes.isStrickLotCodes,
                                                is_for_resetting: this.checkboxes.isEnableSiteReset,
                                                // is_supporting_zipped_document: this.checkboxes.isSupportingZippedDocument,
                                                sublocation_id: this.inputSublocation, email: this.inputEmail,
                                                ecomm_terminal_id:this.inputTerminal, replicated_site_id: this.inputReplicateSiteId,
                                                sublocation: {
                                                    name: this.sublocationName
                                                }
                                        }

                                    }
                // var sitePayload =
                var mergedHash = Object.assign({}, this.site, sitePayload.site);
                // console.log(mergedHash)
                var put_request = await HTTPRequest.putRequest(this.endPoint + 'sites/' + this.profileId, null, {site: mergedHash})
                if(put_request == undefined){
                    this.$emit('refreshPage', event)
                } else {
                    if(put_request["error"] == undefined){
                        this.$emit('refreshPage', event)
                    } else {
                        this.errors = put_request["error"].split(",") //format will change when error message has comma
                        //this.$router.push("/")
                    }
                }
            }
        }
    }
}
</script>

<style>
    textarea {
        resize: none;
    }
</style>
